<div class="recentModels">
    <h2>Explore</h2>
    <!-- <ng-container *ngFor="let model of recentModels">
        <app-model-overview [model]=model *ngIf="model.performance"></app-model-overview>
        <br *ngIf="model.performance"/>
    </ng-container> -->
    <app-home-page-game-tab-view></app-home-page-game-tab-view>
</div>